import { Controller } from "@hotwired/stimulus";
import { fileUploadFunctions } from "../components/file_upload_functions";

export default class extends Controller {
  static targets = [
    "emptyImg",
    "emptyHoverImg",
    "input",
    "filePreview",
    "modalFilePreview",
    "noFileElement",
    "fileLabel",
    "submit",
  ];

  manageDragEnter(event) {
    event.preventDefault();
    this.emptyImgTarget.classList.add("hidden");
    this.emptyHoverImgTarget.classList.remove("hidden");
  }

  manageDragLeave(event) {
    event.preventDefault();
    this.emptyImgTarget.classList.remove("hidden");
    this.emptyHoverImgTarget.classList.add("hidden");
  }

  acceptFile(event) {
    event.preventDefault();
  }

  dropFile(event) {
    event.preventDefault();
    const dataTransfer = event.dataTransfer;
    const droppedFiles = dataTransfer.files;

    const permittedNumberOfFiles = this.inputTarget.dataset.numberOfFiles;
    if (!fileUploadFunctions().numberOfFilesValid(permittedNumberOfFiles, droppedFiles.length)) {
      fileUploadFunctions().alertInvalidFileNumber(permittedNumberOfFiles);
      return;
    }

    const filesFormat = Array.from(droppedFiles).map((file) => file.type);
    if (!fileUploadFunctions().filesFormatValid(filesFormat)) {
      fileUploadFunctions().alertInvalidFileFormat();
      return;
    }

    this.inputTarget.files = droppedFiles;
    const inputEvent = new Event("input");
    this.inputTarget.dispatchEvent(inputEvent);
  }

  displayPreview() {
    const file = this.inputTarget.files[0];

    if (file) {
      this.noFileElementTarget.classList.add("hidden");
      this.filePreviewTarget.classList.remove("hidden");
      this.submitTarget.disabled = false;
      this._loadPreview(file);
    } else {
      this.noFileElementTarget.classList.remove("hidden");
      this.emptyImgTarget.classList.remove("hidden");
      this.emptyHoverImgTarget.classList.add("hidden");
      this.filePreviewTarget.classList.add("hidden");
      this.submitTarget.disabled = true;
    }

    this.fileLabelTarget.innerText = fileUploadFunctions().fileLabelText(file);
  }

  _loadPreview(file) {
    const fileUrl = URL.createObjectURL(file);
    this.filePreviewTarget.innerHTML = fileUploadFunctions().filePreview(fileUrl, file.type, "", {
      pdfToolbarActive: false,
      clickablePdfPreview: true,
    });

    if (this.hasModalFilePreviewTarget) {
      this.modalFilePreviewTarget.innerHTML = fileUploadFunctions().filePreview(
        fileUrl,
        file.type,
        "width_100p height_90vh object-fit_contain",
        { pdfToolbarActive: true }
      );
    }
  }
}
